import { Box, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import React from "react";
import { LoanTypeIcon } from "./LoanTypeIcon";
import Text from "./Text";

export default function InfoBanner({ assetType, proposedBy }) {
  const { palette, shape, spacing } = useTheme();
  const infoBanner = {
    background: palette.grey[100],
    color: palette.text.primary,
    borderRadius: shape.borderRadius,
    padding: `${spacing(2)}px ${spacing(1)}px`,
  };

  return (
    <Box style={infoBanner}>
      <Box display={"flex"} alignItems={"center"}>
        <Box>
          <LoanTypeIcon type={assetType} />
        </Box>
        <Box flexGrow={1}>
          <Typography variant="body2" style={{ textAlign: "left" }}>
            <Text
              tId="PROPOSAL_DETAILS_WITHOUT_AMOUNT"
              dynamicDataTexts={[proposedBy]}
            />
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
